<script>
  import logo from "../assets/logoBW.svg";
</script>

<div id="logo">
  {@html logo}
</div>

<style>
    #logo {
        position: fixed;
        top: 2em;
        left: 3em;
    }
</style>